<template>
  <input
    v-model.number="inputValue"
    type="number"
    min="1"
    onkeypress="return event.charCode >= 48"
    @keyup.enter="submit(inputValue)"
    class="page input-gap"
  />
</template>

<script>
  export default {
    name: 'InputNumber',
    data() {
      return {
        inputValue: null,
      };
    },
    methods: {
      submit(value) {
        this.$emit('inputValue', value || 1);
        this.inputValue = null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/pagination/input_page_number.vue?237cac40